<!--<ara-side-nav class="inside-topnav" [routesFlag]='routesFlag' [reportRoutes]='reportRoutes'></ara-side-nav>-->
<div class="page-content-wrapper">
  <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
    <ol class="breadcrumb bc-3">
      <li>
        <a [routerLink]="'/home'">Home</a>
      </li>
      <li>
        <a>Risk Management</a>
      </li>
    </ol>

    <div class="inner-wrapper">
      <!-- <div class="top-heading center">
        <h4>{{ 'RISK.RISK_REGISTER' | translate }}</h4>
      </div> -->
      <div class="sub-wrapper">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
              {{ "RISK.RISK" | translate }} Register Overview
            </li>
            <li class="filter-sort" (clickOutside)="onClickedOutside()">
              <div class="filter-sort-wrapper">
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#filter"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-filter"
                    aria-hidden="true"
                    pTooltip="Filter"
                    tooltipPosition="top"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideFilter">
                  <ul class="filter-section-wrapper collapse" id="filter">
                    <li>
                      <div class="leave-type">
                        <h5>{{ "RISK.STATUS" | translate }}</h5>
                        <p-multiSelect
                          [options]="status"
                          [(ngModel)]="riskStatus"
                        >
                        </p-multiSelect>
                      </div>
                      <div class="clearfix"></div>
                    </li>
                    <li>
                      <div class="leave-type">
                        <h5>{{ "RISK.SOURCE" | translate }}</h5>
                        <p-multiSelect
                          [options]="riskSources"
                          [(ngModel)]="selectedRiskSources"
                        >
                        </p-multiSelect>
                      </div>
                      <div class="clearfix"></div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="status">
                        <h5>{{ "RISK.RISK_ADDED_ON" | translate }}</h5>
                        <div
                          class="col-lg-12 col-md-11 col-sm-11 no-padding margin-top-10"
                        >
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-left"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [maxDate]="currentDate"
                              [showTime]="true"
                              placeholder="From"
                              dateFormat="dd/mm/yy"
                              [(ngModel)]="riskAddedFromDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            ></p-calendar>
                          </div>
                          <div
                            class="col-lg-6 col-md-6 col-sm-6 no-padding-right"
                          >
                            <p-calendar
                              [showIcon]="true"
                              [minDate]="riskAddedFromDate"
                              [maxDate]="currentDate"
                              dateFormat="dd/mm/yy"
                              [showTime]="true"
                              placeholder="To"
                              [(ngModel)]="riskAddedToDate"
                              class="custom-datepicker"
                              readonlyInput="true"
                              required
                              #timeOfUse="ngModel"
                              monthNavigator="true"
                              yearNavigator="true"
                              yearRange="1950:2100"
                              showButtonBar="true"
                            >
                            </p-calendar>
                          </div>
                          <div class="clearfix"></div>
                        </div>
                        <div class="clearfix"></div>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li>
                      <div class="status">
                        <h5>Unit</h5>
                        <p-multiSelect
                          [options]="unitList"
                          [(ngModel)]="selectedUnit"
                        ></p-multiSelect>
                      </div>
                    </li>
                    <div class="clearfix"></div>
                    <li class="filter-footer">
                      <footer>
                        <a
                          (click)="resetValue()"
                          role="button"
                          class="btn btn-primary primary-btn button-reset"
                        >
                          <i class="fa fa-refresh"></i>reset</a
                        >
                        <a
                          (click)="doneFilter()"
                          role="button"
                          class="btn btn-primary primary-btn button-submit"
                        >
                          <i class="fa fa-check"></i>done</a
                        >
                      </footer>
                    </li>
                  </ul>
                </div>
                <a
                  class="settings"
                  data-toggle="collapse"
                  data-target="#sort-pending-for-assign"
                  (click)="onTabOpen()"
                >
                  <i
                    class="fa fa-sort"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-original-title="Sort"
                  ></i>
                </a>
                <div class="outer-wrapper" *ngIf="hideSort">
                  <ul
                    class="filter-section-wrapper sort-section-wrapper collapse"
                    id="sort-pending-for-assign"
                  >
                    <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ "RISK.RISK_ADDED_ON" | translate }}</label>
                          <a (click)="ascRiskAddedOn()" class="selected">
                            <i
                              class="fa fa-long-arrow-up"
                              aria-hidden="true"
                            ></i>
                          </a>
                          <a> </a>
                          <a (click)="descRiskAddedOn()" class="">
                            <i
                              class="fa fa-long-arrow-down"
                              aria-hidden="true"
                            ></i>
                          </a>
                        </div>
                      </div>
                    </li>
                    <!-- <li>
                      <div class="sort-wrapper">
                        <div class="dt-sort">
                          <label>{{ 'RISK.RISK_RATINGS' | translate }}</label>
                          <a (click)="ascRiskRating()" class="selected">
                            <i class="fa fa-long-arrow-up" aria-hidden="true"></i>
                          </a>
                          <a>
                          </a>
                          <a (click)="descRiskRating()" class="">
                            <i class="fa fa-long-arrow-down" aria-hidden="true"></i>
                          </a>
                        </div>
                      </div>
                    </li> -->
                    <div class="clearfix"></div>
                  </ul>
                </div>
              </div>
              <div class="clearfix"></div>
            </li>
          </ol>
        </nav>
        <div class="section-wrapper">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding">
            <div
              class="col-lg-9 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10"
            >
              <a
                [ngClass]="
                  riskData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="exportToExcel('Export')"
                class="btn btn-primary primary-btn export-btn button-excel"
                role="button"
              >
                <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To Excel
              </a>
              <a
                [ngClass]="
                  riskData.length && !disableExport
                    ? 'cursor-pointer'
                    : 'disabled'
                "
                (click)="downloadZIP()"
                class="btn btn-primary primary-btn export-btn button-zip"
                role="button"
              >
                <i class="fa fa-file-zip-o" style="padding-right: 10px"></i>
                <ng-container *ngIf="window.innerWidth > 823"></ng-container
                >Export To ZIP
              </a>
              <a *ngIf="RiskManagementToolId == HEMPRiskManagementToolId"
            (click)="fileUploadDialog = true"
                    class="btn btn-primary primary-btn export-btn button-excel"
                    role="button"
                  >
                    <i class="fa fa-file-excel-o" style="padding-right: 10px"></i>
                     Bulk Import From Excel
                  </a>
              <label>Risk Management Tool</label>
              <select  class="form-control search-obs manage-tool" value="0" (change)="getRiskDataBySelectedTool(RiskManagementToolId)"
              [(ngModel)]="RiskManagementToolId" [disabled]="disableRisk">
              <option value="0">All</option>
              <option *ngFor="let riskManagement of raiseRiskAllMaster.RiskManagementTool"
                value={{riskManagement.RiskManagementToolId}}
                [selected]="RiskManagementToolId === riskManagement.RiskManagementToolId">
                {{riskManagement.ToolName}}
              </option>
            </select>
            
            </div>
            <div
              class="col-lg-3 col-md-6 col-sm-6 col-xs-6 no-padding margin-top-10 align-right"
            >
            
              <input
                type="text"
                placeholder="Search"
                class="form-control search-obs"
                [(ngModel)]="searchText"
                (keyup.enter)="searchData()"
              />
              <button class="btn btn-primary primary-btn">
                <i
                  class="fa fa-search search"
                  (click)="searchData()"
                  [class.padding]="searchText.length > 0"
                ></i>
                <i
                  class="fa fa-close clear"
                  *ngIf="searchText.length > 0"
                  (click)="clearSearch()"
                ></i>
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="clearfix"></div>
          <div class="table-responsive margin-top-15">
            <table
              class="table table-bordered table-striped table-condensed fix-tablelayout"
            >
              <thead>
                <tr>
                  <th style="width: 30px" rowspan="2">
                    <input
                      type="checkbox"
                      [checked]="isRisksChecked"
                      (change)="selectAllRisks($event.target.checked)"
                      [(ngModel)]="isRisksChecked"
                      [value]="isRisksChecked"
                    />
                  </th>
                  <th style="width: 60px" rowspan="2">
                    {{ "RISK.RISK_ID" | translate }}
                  </th>
                  <th style="width: 150px" rowspan="2">
                    {{ "RISK.UNIT" | translate }}
                  </th>
                  <th style="width: 180px" rowspan="2">
                    Risk Management Tool
                  </th>
                  <th style="width: 75px" rowspan="2">Source</th>
                  <th style="width: 130px" rowspan="2">
                    {{ "RISK.HAZARDS_IDENTIFIED" | translate }}
                  </th>
                  <th style="width: 180px" rowspan="2">
                    {{ "RISK.RISK_ADDED_ON" | translate }}
                  </th>
                  <th style="width: 50px" rowspan="2">Status</th>
                  <th style="width: 160px" rowspan="2">
                    Required Approvals
                  </th>
                  <th style="width: 130px" rowspan="2">
                    Approval Status
                  </th>
                  <th style="width: 60px" rowspan="2">Download</th>
                   <th style="width: 90px" *ngIf="permissions.SUPER_Admin" >Action</th> 
                </tr>
              </thead>
              <tbody>
                <tr
                  (contextmenu)="cm.show($event); showContextMenu(risk)"
                  #row
                  *ngFor="
                    let risk of riskData
                      | paginate
                        : {
                            itemsPerPage: totalRow,
                            currentPage: pageSize,
                            totalItems: rowCount
                          };
                    let i = index
                  "
                  id="{{ risk.DisplayId }}"
                >
                  <td>
                    <span *ngIf="risk.Status === 'Draft'">
                      <input
                        type="checkbox"
                        [disabled]="risk.Status === 'Draft'"
                        (change)="selectRisks(risk, $event)"
                        [value]="risk"
                      />
                    </span>
                    <span *ngIf="risk.Status !== 'Draft'">
                      <input
                        type="checkbox"
                        [(ngModel)]="risk.Checked"
                        [checked]="risk.Checked"
                        (change)="selectRisks(risk, $event)"
                        [value]="risk"
                      />
                    </span>
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    <span *ngIf="risk.Status === 'Draft'" style="color: red"
                      >Draft</span
                    >
                    <span *ngIf="risk.Status !== 'Draft'">{{
                      risk.DisplayId
                    }}</span>
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    {{ risk.UnitName }}
                  </td>
                  <td
                  (click)="getCurrentDOMElementId(risk.DisplayId)"
                  [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                >
                  {{ risk.ToolName }}
                </td>
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    {{ risk.Source }}
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    <span
                      class="ellepsis"
                      data-html="true"
                      data-toggle="popover"
                      pTooltip="{{ risk.HazardIdentified }}"
                      data-content="Lorem Ipsum is simply dummy text of the printing <i class='fa fa-times close-popover'></i>"
                      >{{ risk.HazardIdentified }}</span
                    >
                  </td>
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    {{ risk.CreatedDate | dateTimeFormat }}
                  </td>
                
                  <td
                    (click)="getCurrentDOMElementId(risk.DisplayId)"
                    [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                  >
                    {{ risk.Status }}
                  </td>
                  <td
                  (click)="getCurrentDOMElementId(risk.DisplayId)"
                  [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                >
                  {{ risk.RequiredApproval }}
                  </td>
                <td
                (click)="getCurrentDOMElementId(risk.DisplayId)"
                [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
                >
                {{ risk.ApprovalStatus }}
                </td>
                  <td (click)="Download(risk.RiskRequestId,risk.ToolName)">
                    <i class="fa fa-download"></i>
                  </td>

                  <td *ngIf="permissions.SUPER_Admin">
                    <ara-record-actions *ngIf="risk.Status === 'Deleted'" [SourceId]="risk.RiskRequestId" ModuleName="Risk" ShowRestore="true"  [ShowLabel]="false"  (output)="getOutput($event)" >
                    </ara-record-actions>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              style="width: 500px; margin-top: 15px; color: red"
              *ngIf="!showPagination"
            >
              {{ noRecordsMsg }}
            </div>
            <div style="width: 500px" *ngIf="showPagination">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <div class="card-view">
            <label class="checkbox-inline margin-bottom-10 pull-right"
              ><input
                type="checkbox"
                [checked]="isRisksChecked"
                (change)="selectAllRisks($event.target.checked)"
                [(ngModel)]="isRisksChecked"
                [value]="isRisksChecked"
              />Select All</label
            >
            <div class="clearfix"></div>
            <div
              class="card"
              *ngFor="
                let risk of riskData
                  | paginate
                    : {
                        itemsPerPage: totalRow,
                        currentPage: pageSize,
                        totalItems: rowCount
                      };
                let i = index
              "
            >
              <div
                [popover]="risk.Source"
                popoverTitle="Source"
                popoverPlacement="bottom"
                [popoverOnHover]="false"
                [popoverCloseOnClickOutside]="true"
                [popoverCloseOnMouseOutside]="true"
                [popoverDisabled]="false"
                [popoverAnimation]="true"
                [popoverDismissTimeout]="0"
              >
                <h5 class="card-title">
                  <span class="ellepsis-mobile">{{ risk.Source }}</span>
                  <span>
                    <input
                      type="checkbox"
                      [(ngModel)]="risk.Checked"
                      [checked]="risk.Checked"
                      (change)="selectRisks(risk, $event)"
                      [value]="risk"
                  /></span>
                </h5>
              </div>
              <p
                class="card-sub-title"
                (click)="getCurrentDOMElementId(risk.DisplayId)"
                [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
              >
                <span>{{ risk.DisplayId }}</span> -
                <span>{{ risk.UnitName }}</span>
              </p>
              <p
                (click)="getCurrentDOMElementId(risk.DisplayId)"
                [routerLink]="['/risk/'+ risk.RedirectPage, risk.RiskRequestId]"
              >
                <span>{{ risk.CreatedDate | dateTimeFormat }}</span> -
                <span>{{ risk.Status }}</span>
              </p>
            </div>
            <div style="margin-top: 15px; color: red" *ngIf="!showPagination">
              {{ noRecordsMsg }}
            </div>
            <div class="col-sm-12 col-xs-12" *ngIf="showPagination">
              <pagination-controls
                (pageChange)="getServerData($event)"
              ></pagination-controls>
            </div>
          </div>
          <!-- End table-responsive -->
          <div class="clearfix"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="clearfix"></div>
</div>
<p-contextMenu
  [appendTo]="row"
  [target]="row"
  #cm
  [model]="contextItems"
></p-contextMenu>
  
<p-dialog
[(visible)]="fileUploadDialog"
(onHide)="closePopUp()"
header="Import Data From Excel"
[modal]="true"
[style]="{ width: '500px' }"
>
<div class="p-field">

 
  <label for="name" style="margin-top: 10px">
    Select Excel File:<span class="mandatory">*</span></label>
    <input type="file" (change)="onSelectFile($event)" multiple="false" />
</div>
<ng-template pTemplate="footer">
  <button
    pButton
    pRipple
    label="Import"
    [disabled]="disableImport"
    (click)="ImportBulkExcel()"
    icon="pi pi-check"
    class="p-button-text"
  ></button>
  <button
    pButton
    pRipple
    label="Cancel"
    (click)="fileUploadDialog = false"
    icon="pi pi-times"
    class="p-button-text button-cancel"
  ></button>
</ng-template>
</p-dialog>
<span *ngIf="isShowErrorDialog">
  <p-dialog header="Import Errors" [(visible)]="isShowErrorDialog" (onHide)="ImportErrorclosePopUp()" [modal]="true">
   <ara-import-error [ImportErrorList]="bulkUploadErrors">
   </ara-import-error>
 </p-dialog> 
</span>